export default __webpack_public_path__ + "static/media/SharePoint.63ef6f96.svg";